import { observer } from 'mobx-react-lite';

import { Button } from 'src/shared/components/button';

import styles from './error-message.module.scss';

type Props = {
  headerText: string;
  errorsList: string[];
  onClose(): void;
};

export const ErrorMessage = observer<Props>(function ErrorMessage({ headerText, errorsList, onClose }) {
  return (
    <div className={styles.wrapper}>
      <p className={styles.headerText}>{headerText}</p>
      <ul className={styles.list}>
        {errorsList.map((error) => (
          <li key={error} className={styles.listItem}>
            {error}
          </li>
        ))}
      </ul>
      <Button variant="danger" className={styles.okButton} onClick={onClose}>
        OK
      </Button>
    </div>
  );
});
